import {Component, computed, inject, OnInit} from '@angular/core';
import {GuiaComponent} from '../../../../shared/components/guia-component/guia-component';
import {Router} from '@angular/router';
import { ResultStateService } from '../../services/result.state.service';
import { AnswerResponseDto } from '../../interface/survey-responses.interface';
import { EmptyStateComponent } from '@/app/shared/components/empty-state/empty-state.component';
import { Resultado } from '../../interface/result.inteface';
import { ThemeService } from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-guia2-component',
  imports: [
    GuiaComponent,
    EmptyStateComponent
  ],
  templateUrl: './guia2-component.html',
  standalone: true,
  styleUrl: './guia2-component.scss'
})
export class Guia2Component implements OnInit {
  private resultStateService = inject(ResultStateService);
  private themeService = inject(ThemeService);
  private router = inject(Router);
  private cuestionario!: Resultado | null;

  protected themeContent = this.themeService.themeContent;
  protected guideTwoComponent = computed(() => this.themeContent()?.guideTwoComponent);

  guia2: any[] = [];

  ngOnInit(): void {
    this.cuestionario = this.resultStateService.getCuestionario();

    // Obtener la data real de las respuestas para esta guía específica
    if (this.cuestionario) {
      const surveyAnswers = this.resultStateService.getSurveyAnswersForGuide(this.cuestionario.token, this.cuestionario.guideId!);

      // Si no hay data real, usar mock data como fallback
      if (surveyAnswers && surveyAnswers.length > 0) {
        this.guia2 = this.transformSurveyAnswersToGuiaFormat(surveyAnswers);
        // Ordenar por categoría de A-Z
        this.guia2.sort((a, b) => a.category.localeCompare(b.category, 'es', { sensitivity: 'base' }));
      }
    }
  }

  handleGoBack(){
    this.router.navigate(['resultados']);
  }

  /**
   * Transforma las respuestas del API al formato que espera GuiaComponent
   */
  private transformSurveyAnswersToGuiaFormat(answers: AnswerResponseDto[]): any[] {

    return answers.map(answer => {

      // Buscar la pregunta correspondiente en el mock data para mantener la estructura
      const mockQuestion = this.getMockQuestionByCode(answer.questionCode);

      const transformedAnswer = {
        questionId: answer.questionCode,
        category: mockQuestion?.category,
        domain: mockQuestion?.domain,
        dimension: mockQuestion?.dimension,
        score: Number(answer.responseValue) || 0,
        inverted: mockQuestion?.inverted,
        text: mockQuestion?.text
      };

      return transformedAnswer;
    });
  }

 /**
   * Busca la pregunta correspondiente en el mock data por questionCode
   */
  private getMockQuestionByCode(questionCode: string): any {
    const mockData = [
    {
      "questionId": "GII_1",
      "category": "Ambiente de trabajo",
      "domain": "Condiciones en el ambiente de trabajo",
      "dimension": "Condiciones deficientes e insalubres",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo me exige hacer mucho esfuerzo físico"
    },
    {
      "questionId": "GII_2",
      "category": "Ambiente de trabajo",
      "domain": "Condiciones en el ambiente de trabajo",
      "dimension": "Condiciones peligrosas e inseguras",
      "score": 4,
      "inverted": false,
      "text": "Me preocupa sufrir un accidente en mi trabajo"
    },
    {
      "questionId": "GII_3",
      "category": "Ambiente de trabajo",
      "domain": "Condiciones en el ambiente de trabajo",
      "dimension": "Trabajos peligrosos",
      "score": 4,
      "inverted": false,
      "text": "Considero que las actividades que realizo son peligrosas"
    },
    {
      "questionId": "GII_4",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas cuantitativas",
      "score": 4,
      "inverted": false,
      "text": "Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno"
    },
    {
      "questionId": "GII_5",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Ritmos de trabajo acelerado",
      "score": 4,
      "inverted": false,
      "text": "Por la cantidad de trabajo que tengo debo trabajar sin parar"
    },
    {
      "questionId": "GII_6",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Ritmos de trabajo acelerado",
      "score": 4,
      "inverted": false,
      "text": "Considero que es necesario mantener un ritmo de trabajo acelerado"
    },
    {
      "questionId": "GII_7",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Carga mental",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo exige que esté muy concentrado"
    },
    {
      "questionId": "GII_8",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Carga mental",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo requiere que memorice mucha información"
    },
    {
      "questionId": "GII_9",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas cuantitativas",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo exige que atienda varios asuntos al mismo tiempo"
    },
    {
      "questionId": "GII_10",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas de alta responsabilidad",
      "score": 4,
      "inverted": false,
      "text": "En mi trabajo soy responsable de cosas de mucho valor"
    },
    {
      "questionId": "GII_11",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas de alta responsabilidad",
      "score": 4,
      "inverted": false,
      "text": "Respondo ante mi jefe por los resultados de toda mi área de trabajo"
    },
    {
      "questionId": "GII_12",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Cargas contradictorias o inconsistentes",
      "score": 4,
      "inverted": false,
      "text": "En mi trabajo me dan órdenes contradictorias"
    },
    {
      "questionId": "GII_13",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Cargas contradictorias o inconsistentes",
      "score": 4,
      "inverted": false,
      "text": "Considero que en mi trabajo me piden hacer cosas innecesarias"
    },
    {
      "questionId": "GII_14",
      "category": "Organización del tiempo de trabajo",
      "domain": "Jornada de trabajo",
      "dimension": "Jornadas de trabajo extensas",
      "score": 4,
      "inverted": false,
      "text": "Trabajo horas extras más de tres veces a la semana"
    },
    {
      "questionId": "GII_15",
      "category": "Organización del tiempo de trabajo",
      "domain": "Jornada de trabajo",
      "dimension": "Jornadas de trabajo extensas",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo me exige laborar en días de descanso, festivos o fines de semana"
    },
    {
      "questionId": "GII_16",
      "category": "Organización del tiempo de trabajo",
      "domain": "Interferencia en la relación trabajo-familia",
      "dimension": "Influencia del trabajo fuera del centro laboral",
      "score": 4,
      "inverted": false,
      "text": "Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales"
    },
    {
      "questionId": "GII_17",
      "category": "Organización del tiempo de trabajo",
      "domain": "Interferencia en la relación trabajo-familia",
      "dimension": "Influencia de las responsabilidades familiares",
      "score": 4,
      "inverted": false,
      "text": "Pienso en las actividades familiares o personales cuando estoy en mi trabajo"
    },
    {
      "questionId": "GII_18",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Limitada o nula posibilidad de desarrollo",
      "score": 4,
      "inverted": true,
      "text": "Mi trabajo permite que desarrolle nuevas habilidades"
    },
    {
      "questionId": "GII_19",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Limitada o nula posibilidad de desarrollo",
      "score": 4,
      "inverted": true,
      "text": "En mi trabajo puedo aspirar a un mejor puesto"
    },
    {
      "questionId": "GII_20",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Falta de control y autonomía sobre el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Durante mi jornada de trabajo puedo tomar pausas cuando las necesito"
    },
    {
      "questionId": "GII_21",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Falta de control y autonomía sobre el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Puedo decidir la velocidad a la que realizo mis actividades en mi trabajo"
    },
    {
      "questionId": "GII_22",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Falta de control y autonomía sobre el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Puedo cambiar el orden de las actividades que realizo en mi trabajo"
    },
    {
      "questionId": "GII_23",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Liderazgo",
      "dimension": "Escasa claridad de funciones",
      "score": 4,
      "inverted": true,
      "text": "Me informan con claridad cuáles son mis funciones"
    },
    {
      "questionId": "GII_24",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Liderazgo",
      "dimension": "Escasa claridad de funciones",
      "score": 4,
      "inverted": true,
      "text": "Me explican claramente los resultados que debo obtener en mi trabajo"
    },
    {
      "questionId": "GII_25",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Liderazgo",
      "dimension": "Escasa claridad de funciones",
      "score": 4,
      "inverted": true,
      "text": "Me informan con quién puedo resolver problemas o asuntos de trabajo"
    },
    {
      "questionId": "GII_26",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Limitada o inexistente capacitación",
      "score": 4,
      "inverted": true,
      "text": "Me permiten asistir a capacitaciones relacionadas con mi trabajo"
    },
    {
      "questionId": "GII_27",
      "category": "Factores propios de la actividad",
      "domain": "Falta de control sobre el trabajo",
      "dimension": "Limitada o inexistente capacitación",
      "score": 4,
      "inverted": true,
      "text": "Recibo capacitación útil para hacer mi trabajo"
    },
    {
      "questionId": "GII_28",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Liderazgo",
      "dimension": "Características del liderazgo",
      "score": 4,
      "inverted": true,
      "text": "Mi jefe tiene en cuenta mis puntos de vista y opiniones"
    },
    {
      "questionId": "GII_29",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Liderazgo",
      "dimension": "Características del liderazgo",
      "score": 4,
      "inverted": true,
      "text": "Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo"
    },
    {
      "questionId": "GII_30",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Relaciones sociales en el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Puedo confiar en mis compañeros de trabajo"
    },
    {
      "questionId": "GII_31",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Relaciones sociales en el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Cuando tenemos que realizar trabajo de equipo los compañeros colaboran"
    },
    {
      "questionId": "GII_32",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Relaciones sociales en el trabajo",
      "score": 4,
      "inverted": true,
      "text": "Mis compañeros de trabajo me ayudan cuando tengo dificultades"
    },
    {
      "questionId": "GII_33",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": true,
      "text": "En mi trabajo puedo expresarme libremente sin interrupciones"
    },
    {
      "questionId": "GII_34",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Recibo críticas constantes a mi persona y/o trabajo"
    },
    {
      "questionId": "GII_35",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones"
    },
    {
      "questionId": "GII_36",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Se ignora mi presencia o se me excluye de las reuniones de trabajo y en la toma de decisiones"
    },
    {
      "questionId": "GII_37",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Se manipulan las situaciones de trabajo para hacerme parecer un mal trabajador"
    },
    {
      "questionId": "GII_38",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Se ignora mis éxitos laborales y se atribuyen a otros trabajadores"
    },
    {
      "questionId": "GII_39",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "Me bloquean o impiden las oportunidades que tengo para obtener ascenso o mejora en mi trabajo"
    },
    {
      "questionId": "GII_40",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Violencia",
      "dimension": "Violencia laboral",
      "score": 4,
      "inverted": false,
      "text": "He presenciado actos de violencia en mi centro de trabajo"
    },
    {
      "questionId": "GII_41",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas psicológicas emocionales",
      "score": 4,
      "inverted": false,
      "text": "Atiendo clientes o usuarios muy enojados"
    },
    {
      "questionId": "GII_42",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas psicológicas emocionales",
      "score": 4,
      "inverted": false,
      "text": "Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas"
    },
    {
      "questionId": "GII_43",
      "category": "Factores propios de la actividad",
      "domain": "Carga de trabajo",
      "dimension": "Cargas psicológicas emocionales",
      "score": 4,
      "inverted": false,
      "text": "Para hacer mi trabajo debo demostrar sentimientos distintos a los míos"
    },
    {
      "questionId": "GII_44",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Deficiente relación con los colaboradores que supervisa",
      "score": 4,
      "inverted": false,
      "text": "Comunican tarde los asuntos de trabajo"
    },
    {
      "questionId": "GII_45",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Deficiente relación con los colaboradores que supervisa",
      "score": 4,
      "inverted": false,
      "text": "Dificultan el logro de los resultados del trabajo"
    },
    {
      "questionId": "GII_46",
      "category": "Liderazgo y relaciones en el trabajo",
      "domain": "Relaciones en el trabajo",
      "dimension": "Deficiente relación con los colaboradores que supervisa",
      "score": 4,
      "inverted": false,
      "text": "Ignoran las sugerencias para mejorar su trabajo"
    }
    ];

      return mockData.find(q => q.questionId === questionCode);
  }
}
